



































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
import CouponHelpers, { Coupon } from "@/models/coupon";
const log = NSLog("view/ManageCoupons");

@Component({
  components: {
    loader,
  },
})
export default class ListRules extends Vue {
  @Mutation("setLastErr") public setLastErr: any;

  loading = false;
  trigger: string = "";
  filter: string = "";
  action: string = "";

  get filters() {
    return (
      this.triggers.find(
        (t) => t.value == this.trigger && t.filters && t.filters.length
      ) || { filters: null }
    ).filters;
  }

  get actions() {
    return (
      this.triggers.find(
        (t) => t.value == this.trigger && t.filters && t.filters.length
      ) || { actions: null }
    ).actions;
  }

  get triggers() {
    return [
      {
        value: "accountdeliveryitem.draft",
        title: "Delivery Item - New Draft",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountdeliveryitem.pending_payment",
        title: "Delivery Item - Pending Payment",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountdeliveryitem.waiting_stock",
        title: "Delivery Item - Waiting Stock",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountdeliveryitem.processing",
        title: "Delivery Item - Processing",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountdeliveryitem.pending_pickup",
        title: "Delivery Item - Pending Pickup",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountdeliveryitem.picked_up",
        title: "Delivery Item - Picked Up",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountdeliveryitem.pending_courier_pickup",
        title: "Delivery Item - Pending Courier Pickup",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountdeliveryitem.shipping",
        title: "Delivery Item - Shipping",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountdeliveryitem.delivered",
        title: "Delivery Item - Delivered",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountinvoice.draft",
        title: "Invoice - Draft",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountinvoice.created",
        title: "Invoice - Created",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountinvoice.pending_payment",
        title: "Invoice - Pending Payment",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountinvoice.paying",
        title: "Invoice - Paying",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountinvoice.payment_failed",
        title: "Invoice - Payment Failed",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountinvoice.payment_retry",
        title: "Invoice - Payment Retry",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountinvoice.paid",
        title: "Invoice - Paid",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountinvoice.final_payment_attempt_failed",
        title: "Invoice - Final Payment Attempt Failed",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountinvoice.canceled",
        title: "Invoice - Canceled",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountlicence.active",
        title: "License - Active",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountlicence.renewing",
        title: "License - Renewing",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountlicence.pending_cancel",
        title: "License - Pending Cancel",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountlicence.cancelled",
        title: "License - Cancelled",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountorder.draft",
        title: "Order - New Draft",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountorder.pending_approval",
        title: "Order - Pending Approval",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountorder.approval_declined",
        title: "Order - Approval Declined",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountorder.created",
        title: "Order - Created",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountorder.approved",
        title: "Order - Approved",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountorder.paid",
        title: "Order - Paid",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountsubscription.draft",
        title: "Subscription - New Draft",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountsubscription.active",
        title: "Subscription - Active",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountsubscription.renewing",
        title: "Subscription - Renewing",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountsubscription.renewed",
        title: "Subscription - Renewed",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountsubscription.pending_payment",
        title: "Subscription - Pending Payment",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountsubscription.pending_cancel",
        title: "Subscription - Pending Cancel",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountsubscription.cancelled",
        title: "Subscription - Cancelled",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accountsubscription.pending_trial_create",
        title: "Subscription - Pending Trial Create",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accounttrial.activated",
        title: "Trial - Activated",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "accounttrial.discontinued",
        title: "Trial - Discontinued",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "transaction.new",
        title: "Transaction - New",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "transaction.confirmed",
        title: "Transaction - Confirmed",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "transaction.failed",
        title: "Transaction - Failed",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
      {
        value: "transaction.canceled",
        title: "Transaction - Canceled",
        filters: [{ value: "containes_package", title: "Contains Package" }],
        actions: [{ value: "send_mail", title: "Send Email" }],
      },
    ];
  }
}
